var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUUsersAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D66700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 29C18.5 29 17 29 17 27.5C17 26 18.5 21.5 24.5 21.5C30.5 21.5 32 26 32 27.5C32 29 30.5 29 30.5 29H18.5ZM24.5 20C25.6935 20 26.8381 19.5259 27.682 18.682C28.5259 17.8381 29 16.6935 29 15.5C29 14.3065 28.5259 13.1619 27.682 12.318C26.8381 11.4741 25.6935 11 24.5 11C23.3065 11 22.1619 11.4741 21.318 12.318C20.4741 13.1619 20 14.3065 20 15.5C20 16.6935 20.4741 17.8381 21.318 18.682C22.1619 19.5259 23.3065 20 24.5 20ZM15.824 29C15.6017 28.5317 15.4908 28.0183 15.5 27.5C15.5 25.4675 16.52 23.375 18.404 21.92C17.4638 21.6297 16.484 21.4879 15.5 21.5C9.5 21.5 8 26 8 27.5C8 29 9.5 29 9.5 29H15.824ZM14.75 20C15.7446 20 16.6984 19.6049 17.4017 18.9017C18.1049 18.1984 18.5 17.2446 18.5 16.25C18.5 15.2554 18.1049 14.3016 17.4017 13.5983C16.6984 12.8951 15.7446 12.5 14.75 12.5C13.7554 12.5 12.8016 12.8951 12.0983 13.5983C11.3951 14.3016 11 15.2554 11 16.25C11 17.2446 11.3951 18.1984 12.0983 18.9017C12.8016 19.6049 13.7554 20 14.75 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUUsersAlt);
export default __webpack_public_path__ + "static/media/u_users-alt.8e7835076a9241804b46cadca57246c0.svg";
export { ForwardRef as ReactComponent };